import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {I18n, Translate} from 'react-redux-i18n';
import {Tooltip} from '@material-ui/core';
import {Icon} from 'front-onceforall-core';
import GaugeChart from 'react-gauge-chart';
import {Skeleton} from '@material-ui/lab';
import {useDossierCountry} from '../../../OrganisationDashboardContainer';

function SubcontractorStatsView({stats}) {
  const dossierCountry = useDossierCountry();

  function getRatio() {
    const values = stats.count[dossierCountry];

    if (stats.loading || !values) {
      return 0;
    }

    const total = values.VALID + values.INVALID;
    return Number((values.VALID / total).toFixed(2));
  }

  return (
    <div className="card h-100">
      <div className="card-header">
        <div className="card-title flex-container space-between w-100">
          <Translate value="dashboard.stats.subcontractors.title"/>
          <Tooltip title={<Translate value="dashboard.stats.link.subcontractors"/>}>
            <Link to="/subcontractors">
              <Icon
                icon="eye"
                color="tertiary"
              />
            </Link>
          </Tooltip>
        </div>
      </div>
      <div className="flex-container column center">
        <div
          className="w-100"
          style={{maxWidth: 350}}
        >
          <GaugeChart
            id="chart-subcontractors"
            nrOfLevels={3}
            colors={['#fb3958', '#ffa21a', '#3fd2b0']}
            needleColor="#888"
            needleBaseColor="#888"
            textColor="#333"
            animDelay={0}
            hideText={stats.loading}
            fontSize="40px"
            arcPadding={0.03}
            cornerRadius={2}
            percent={getRatio()}
          />
        </div>
        <div className="font-size-l text-center m-0 w-100">
          {stats.loading ?
            <div className="flex-container column">
              <Skeleton
                variant="rect"
                height={15}
                width={'100%'}
              />
              <Skeleton
                variant="rect"
                height={15}
                width={'100%'}
              />
            </div> :
            <Translate
              value="dashboard.stats.subcontractors.valid"
              nationality={I18n.t(`dashboard.stats.subcontractors.nationality.${dossierCountry}`)}
            />
          }
        </div>
      </div>
    </div>
  );
}

SubcontractorStatsView.propTypes = {
  stats: PropTypes.object.isRequired
};

export default SubcontractorStatsView;
